import { TAIL_RULE } from './chip'

/**
 * LA NOTA DELLA TESTATA IN CODA ALL'ARTICOLO: che cos'è, e che cosa non è, quello che si è letto.
 *
 * Il testo arriva da `tenants.articlePolicy` — PER-SITO, non per-articolo — e questo è il punto:
 * dire «non sono raccomandazioni di investimento» è una posizione della testata, valida su tutto
 * ciò che pubblica, e affidarla al singolo pezzo significa affidarla a chi lo scrive (un modello,
 * nella pipeline di questo progetto) e ritrovarla su alcuni articoli e non su altri. Su Bull & Bear
 * è la nota che qualifica un'analisi di politica monetaria e la distingue da un consiglio operativo:
 * o c'è su tutti, o non serve a niente.
 *
 * STA DOPO IL CORPO E PRIMA DEI TAG, cioè attaccata al testo che qualifica. Sotto le fonti e la
 * firma diventerebbe il piede della pagina — la riga che si legge come boilerplate del sito e non
 * come nota su questo articolo — e sarebbe separata da tre blocchi da ciò di cui parla.
 *
 * NIENTE OCCHIELLO, a differenza delle quattro sezioni della coda («Informazioni pratiche», «Tag»,
 * «Fonti», «A cura di»): quelle sono sezioni dell'articolo, questa è una nota sull'articolo — lo
 * stesso registro di <Provenance> in testata, che è l'altra riga in cui il sito parla in prima
 * persona di come è fatto quello che pubblica.
 *
 * OGNI RIGA DEL CAMPO È UN CAPOVERSO. Il campo è una textarea, quindi gli invii che chi scrive
 * batte esistono: senza questo passaggio finirebbero in un unico blocco di testo (in HTML `\n` è
 * spazio bianco), cioè il testo si vedrebbe diverso da come lo si è composto in admin.
 */
export default function ArticlePolicy({ text }: { text?: string | null }) {
  const paragraphs = (text ?? '')
    .split(/\r?\n/)
    .map((p) => p.trim())
    .filter(Boolean)

  if (!paragraphs.length) return null

  // NIENTE MARGINE QUI: la distanza fra i blocchi della coda la tiene il contenitore in
  // <ArticleView> (vedi `TAIL_RULE`), che è l'unico a sapere quali di quei blocchi esistono
  // davvero su questo articolo.
  return (
    <div className={`${TAIL_RULE} space-y-2 text-xs leading-relaxed text-zinc-500`}>
      {paragraphs.map((p, i) => (
        <p key={i}>{p}</p>
      ))}
    </div>
  )
}
